import { FunctionComponent, ReactNode } from 'react';
import './styles.scss';

interface CardProps {
  children: ReactNode;
  nested?: boolean;
  className?: string;
}

const Card: FunctionComponent<CardProps> = ({ children, nested, className }) => {
  const classNames = ['card', nested && 'card--nested', className].filter(Boolean).join(' ');

  return <div className={classNames}>{children}</div>;
};

export default Card;
